import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserEmployeeAssignment } from '../../../shared/interfaces';
import { AppSettings } from '../../../shared/models';
import { AbstractBasicDataApiService } from '../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class UserEmployeeAssignmentApiService extends AbstractBasicDataApiService<UserEmployeeAssignment> {

  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.application.userEmployeeAssignment);
  }
}
